module.exports = __webpack_public_path__ + "img/boat_driving.e6081088.svg";